import { AlertOutlined } from "@ant-design/icons";
import { IDrone } from "@drone-parts.garphild.pro/interfaces";
import CheckListShort from "../../check-list-short";
import { BASE_CHECKLIST } from "../../../../../constants";

interface IChecklistTabProps {
  drone: IDrone;
}

export default function ChecklistTab({ drone }: IChecklistTabProps) {
  return (
    <>
      {drone.checklist?.filter((cli) => cli.value)?.length !== BASE_CHECKLIST.length ? (
        <AlertOutlined style={{ color: "red" }} />
      ) : null}
      {drone.checklist?.filter((cli) => cli.value)?.length}/{BASE_CHECKLIST.length}
      <CheckListShort drone={drone} />
    </>
  );
}
